/**
 * Parses the #srp-initial script content (escaped JSON) into SrpViewModel or a bootstrap payload.
 * When the server sends { _fetch: true }, the island should fetch the full view model from /api/srp-state.
 */
import type { SrpViewModel } from './SrpViewModel';

export type SrpInitialPayload = SrpViewModel | { _fetch: true };

export function parseSrpInitialScript(scriptText: string): SrpInitialPayload | null {
  try {
    const parsed = JSON.parse(scriptText) as Record<string, unknown>;
    if (!parsed || typeof parsed !== 'object') return null;
    if ('_fetch' in parsed && parsed._fetch === true) return { _fetch: true };
    const vm = parsed as SrpViewModel;
    return typeof vm.locale === 'string' && Array.isArray(vm.jobs) ? vm : null;
  } catch {
    return null;
  }
}
